import { useCallback } from "react";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { ISchoolLevelWithAcademicBackEndModel } from "../types";

export default function () {
  const { request } = useApi();
  return {
    fetchAllWithAcademic: useCallback(
      async (id): Promise<{ data: ISchoolLevelWithAcademicBackEndModel[] }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.SCHOOL_LEVELS_WITH_ACADEMIC, { id })}`,
        });
      },
      [request],
    ),
  };
}
